import React from "react";

const EmptyViewJobs = ({
    title = "",
    description = "",
}) => {
    return (
        <div className="bg-white rounded-[14px] border border-[#e4e5e7] p-[48px] text-center">

            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-[32px] h-[32px] text-[#c0c2c6] mx-auto mb-[12px]"
            >
                <polyline points="22 12 16 12 14 15 10 15 8 12 2 12" />
                <path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" />
            </svg>

            <p className="font-semibold text-[15px] text-[#212326] mb-[4px]">
                {title}
            </p>

            <p className="font-medium text-[13px] text-[#9298a0]">
                {description}
            </p>
        </div>
    );
};

export default EmptyViewJobs;